export default __webpack_public_path__ + "static/media/map.7f41338d.svg";